<script>
export default {
  name: 'UlHr',
};
</script>
<template>
  <div class="ul-hr">
    <span>
    <slot></slot>
    </span>
  </div>
</template>
<style lang="scss">
  .ul-hr {
    position: relative;
    padding: 16px 0 8px 0;
    font-size: 16px;
    color: #777777;

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: calc(50% + 4px);
      height: 1px;
      width: 100%;
      background: #999999;
    }

    span {
      display: inline-block;
      margin: 0 8px;
      padding: 0 8px;
      background: #ffffff;
      position: relative;
    }
  }
</style>
